<template lang="pug">
v-container
  v-row
    v-col(cols="12").d-flex.align-center
      v-tooltip(bottom)
        template(v-slot:activator="{on}")
          v-btn.rounded.mr-2(@click="$router.go(-1)" color="secondary" fab tile small v-on="on")
            v-icon mdi-chevron-left
        span Вернуться назад
      h1 Создание новой задачи
    v-col(cols="12")
      v-card(outlined)
        v-card-text
          v-form(v-model="valid")
            v-text-field(
              v-model="form.name"
              label="Введите название задачи"
              :rules="[rules.required]"
              filled
            )

            v-textarea(
              label="Введите описание задачи"
              v-model="form.description"
              :rules="[rules.required]"
              filled
            )
            select-region(
              v-model="addForm.region"
              filled
              :rules="[rules.required]"
              label="Выберите регион исполнителя"
            )
            select-mun(
              v-model="addForm.mun"
              :region="addForm.region"
              :disabled="!addForm.region"
              filled
              label="Выберите муниципалитет исполнителя"
            )
            select-my-user(
              multiple
              v-model="addUser"
              label="Назначьте исполнителя"
              :rules="[rules.required]"
              filled
              return-object
            )

            date-time-picker(
              v-model="form.notify_at"
              label="Укажите дату и в время завершения задачи"
              filled
            )

            v-slider(
              v-model="form.advance_notify_day"
              :label="`Напомнить исполнителю о необходимости выполнения за ${form.advance_notify_day} дней`"
              thumb-label="always"
              step="1"
              max="7"
              color="primary"
            )

          v-card.pa-4.mb-2.d-flex(style="overflow-x:auto" outlined)
            template(v-if="selectedFolder")
              v-btn.mr-4(
                @click="selectedFolder = null"
                color="secondary"
                height="80px"
                width="80px"
              )
                v-icon mdi-chevron-left
              Element(
                v-for="(file, index) in folders[currentFolderIndex].files"
                :key="index"
                :url="file.url"
                :showEdit="false"
                show-actions
                :name="file.original_name || file.name"
                @delete="folders[currentFolderIndex].files.splice(index, 1)"
              )
              uploader(@upload="folders[currentFolderIndex].files.push($event)")
                template(#activator)
                  v-btn.mr-4(
                    color="success"
                    height="80px"
                    width="80px"
                  )
                    v-icon mdi-plus
            template(v-else)
              v-btn.mr-4(@click="folderDialog = true" color="success" height="80px" width="80px")
                v-icon mdi-folder-plus-outline
              uploader(@upload="mainFiles.push($event)")
                template(#activator)
                  v-btn.mr-4(
                    color="success"
                    height="80px"
                    width="80px"
                  )
                    v-icon mdi-plus
              folder(
                v-for="folder in folders"
                :key="folder.id"
                :name="folder.name"
                @click="selectedFolder = folder.id"
              )
              Element(
                :showEdit="false"
                show-actions
                v-for="(file, index) in mainFiles"
                :key="index"
                :url="file.url"
                @delete="mainFiles.splice(index, 1)"
                :name="file.original_name || file.name"
              )
        v-card-actions
          v-row
            v-col(cols="12")
              v-btn.mr-4(
                x-large
                width="100%"
                color="success"
                @click="createNewTask"
              ) Сохранить
  v-dialog(v-model="folderDialog" width="400px")
    v-card(flat dark).pa-4
      p.title Создание папки
      v-text-field(v-model="folderName" filled label="Название папки")
      v-btn(@click="createFolder" color="primary" :disabled="folderName.length < 5").mr-2 Создать
      v-btn(@click="folderDialog = false" text) Отменить
</template>
<script>
import Folder from '@/components/icons/Folder.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import rules from '@/lib/rules';
import { isImage } from '@/lib';
import Element from '@/components/icons/Element.vue';
import Uploader from '@/components/core/Uploader.vue';
import SelectMyUser from '@/components/inputs/SelectMyUser.vue';
import taskServices, { CRUDTasks } from '@/services/API/task';
import { mapGetters } from 'vuex';
import mixinDateTime from '@/mixins/mixinDateTime';
import FolderApi, { CRUDFolders } from '@/services/API/folder';
import SelectRegion from '@/components/inputs/SelectRegion.vue';
import SelectMun from '@/components/inputs/SelectMun.vue';

const ADDICTINAL_FORM = {
  region: '',
  mun: '',
};

const DEFAULT_FORM = {
  status: 1,
  name: '',
  description: '',
  users: [],
  owner_id: null,
  documents: [],
  images: [],
  is_favorite: false,
  notify_at: false,
  advance_notify_day: 1,
};

export default {
  components: {
    SelectRegion,
    SelectMun,
    SelectMyUser,
    Element,
    Uploader,
    DateTimePicker,
    Folder,
  },
  mixins: [mixinDateTime],
  data() {
    return {
      mainFiles: [],
      valid: false,
      dialog: false,
      form: { ...DEFAULT_FORM },
      addForm: { ...ADDICTINAL_FORM },

      selectedFolder: null,
      folderDialog: false,
      folderName:'',
      folders: [], // [{name:String, id:Number, files: { name: String, id: Number}}]
      rules,
      addUser: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
    currentFolderIndex() {
      return this.folders.findIndex(({ id }) => id === this.selectedFolder);
    },
    getRegion() {
      return this.addForm.region;
    },
    getMun() {
      return this.addForm.mun;
    },
  },
  watch: {
    getRegion: {
      handler() {
        this.addForm.mun = null;
        this.addUser = null;
      },
    },
    getMun: {
      handler() {
        this.addUser = null;
      },
    },
  },
  methods: {
    async createNewTask() {
      try {
        const images =  this.mainFiles.filter(({ file_name }) => isImage(file_name));
        const documents = this.mainFiles.filter(({ file_name }) => !isImage(file_name));
        const params = {
          ...this.form,
          'images': images.map(({ file_name }) => file_name),
          'documents': documents.map(({ file_name }) => file_name),
        };

        params.notify_at = this.parseDate(new Date(this.form.notify_at));

        params.owner_id = this.user.id;

        const response = await CRUDTasks.create(params);
        const { id } = response.data.data;
        await this.createFoldersForTask(id);
        await this.attachUser(response.data.data.id);
        this.$toast.success('Задача успешно создана');
        this.$router.push('/tasks');
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },

    async createFolder() {
      this.folders.push({ name: this.folderName, files:[], id: Date.now() });
      this.folderName = '';
      this.folderDialog = false;
    },

    async createFoldersForTask(id) {
      try {
        this.folders.forEach(async (val) => {
          const params = {
            'target_id': id,
            'type': 1,
            'name': val.name,
          };
          const response = await CRUDFolders.create(params);
          const folderID = response.data.data.id;
          //  ATTACH FILES
          const { files } = val;
          await this.attachFileIntoFolder(folderID, files);
        });
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async attachFileIntoFolder(id, files) {
      let params = {};
      try {
        files.forEach((file) => {
          if (isImage(file.file_name)) params = { images: [file.file_name] };
          if (!isImage(file.file_name)) params = { documents: [file.file_name] };
          FolderApi.addFiles(id, params);
        });
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async attachUser(id) {
      try {
        const userIds = this.addUser.map((val) => val.id);
        await taskServices.attachUser(id, [...userIds]);
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
    },
  },
};
</script>
<style scoped />
